<template>
  <div class="wrap">
    <img class="img-bg1" src="@/assets/images/bg.png" alt="" />
    <img class="img-bg2" src="@/assets/images/bg.png" alt="" />
    <img class="img-bg3" src="@/assets/images/bg.png" alt="" />
    <div class="text-content">
      <div class="text-title">{{login.title || ''}}</div>
      <div class="text-desc">{{login.desc || ''}}</div>
    </div>
    <div class="area">
      <div class="top">
        <div class="text">欢迎登录</div>
        <div class="tips">
          没有账号?去<router-link to="register">注册></router-link>
        </div>
      </div>
      <div class="content">
        <el-form :model="form" :rules="formRules" ref="form">
          <el-form-item prop="email">
            <el-input
              v-model="form.email"
              maxlength="50"
              placeholder="请输入邮箱"
              @keyup.native.enter="handleLogin"
            >
              <i slot="prefix" class="el-input__icon">
                <img src="@/assets/images/Icon/user.svg" alt="">
              </i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="form.password"
              maxlength="20"
              show-password
              placeholder="请输入密码"
              @keyup.native.enter="handleLogin"
            >
              <i slot="prefix" class="el-input__icon">
                <img src="@/assets/images/Icon/password.svg" alt="">
              </i>
            </el-input>
          </el-form-item>
          <div class="forget" >
            <span @click="handleForget">忘记密码</span>
          </div>
        </el-form>
      </div>
      <div class="bottom">
        <el-button type="primary" @click="handleLogin" :loading="isLoading">登录</el-button>
      </div>
    </div>
    <retrievePassword ref="edit" @modify-success="handleModify"></retrievePassword>
    <userTips ref="tips" :isModify="true" :email="userEmail"></userTips>
  </div>
</template>

<script>
import retrievePassword from '@/components/retrieve-password-d.vue'
import { loginApi } from '@/api/api.js';
import { login, formRules } from '@/utils/helper.js'
import userTips from '@/components/user-tips.vue'
export default {
  components: { retrievePassword, userTips },
  data () {
    return {
      // 密码错误五次之后  锁定登录一小时
      // 天眼使用方案为针对邮箱进行封锁，由后端进行判断并返回封锁时间
      login,
      errorCount: 0,
      isLocked: false,
      isLoading: false,
      form: {
        email: '',
        password: ''
      },
      userEmail: '',
      formRules: {
        email: [
          // { pattern: /\s/, message: '测试' },
          { validator: formRules.emailValid, trigger: 'change' }
        ],
        password: [
          { required: true, message: '密码不能为空!' }
        ]
      }
    };
  },
  mounted () {},
  methods: {
    handleModify (email) {
      this.userEmail = email
      this.$refs.tips.showDialog();
    },
    handleForget () {
      this.$refs.edit && this.$refs.edit.showDialog();
    },
    handleLogin () {
      this.$refs.form && this.$refs.form.validate(valid => {
        if (valid) {
          let params = {
            ...this.form
            // password: this.form.password // this.$md5(this.form.password)
          }
          this.isLoading = true;
          loginApi.login(params).then(res => {
            this.isLoading = false;
            if (res.status === 10000) {
              console.log(res, 'loginres')
              this.$emit('userLogin')
              this.$message.success('登录成功!')
              this.$router.push('/')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/login.scss';
.wrap {
  .area {
    .bottom {
      padding-top: 30px;
      ::v-deep .el-button {
        width: 100%;
      }
    }
  }
}
</style>
